(function () {
  'use strict';

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise(function (resolve, reject) {
      var area = document.createElement('textarea');
      area.value = text;
      area.setAttribute('readonly', '');
      area.style.position = 'fixed';
      area.style.opacity = '0';
      area.style.pointerEvents = 'none';
      document.body.appendChild(area);
      area.select();

      try {
        document.execCommand('copy') ? resolve() : reject(new Error('Copy failed'));
      } catch (error) {
        reject(error);
      }

      document.body.removeChild(area);
    });
  }

  function showCopiedTooltip(target, event) {
    var oldTooltip = document.getElementById('sm-sku-copy-tooltip');
    if (oldTooltip) oldTooltip.remove();

    var tooltip = document.createElement('span');
    tooltip.id = 'sm-sku-copy-tooltip';
    tooltip.textContent = 'Copied';
    tooltip.setAttribute('role', 'status');

    var rect = target.getBoundingClientRect();
    var x = event && typeof event.clientX === 'number' ? event.clientX : rect.left + (rect.width / 2);
    var y = event && typeof event.clientY === 'number' ? event.clientY : rect.top;

    tooltip.style.position = 'fixed';
    tooltip.style.left = x + 'px';
    tooltip.style.top = Math.max(8, y - 12) + 'px';
    tooltip.style.transform = 'translate(-50%, -100%)';
    tooltip.style.zIndex = '2147483647';
    tooltip.style.padding = '4px 7px';
    tooltip.style.borderRadius = '3px';
    tooltip.style.background = '#222';
    tooltip.style.color = '#fff';
    tooltip.style.fontSize = '12px';
    tooltip.style.fontFamily = 'Arial, sans-serif';
    tooltip.style.lineHeight = '1.2';
    tooltip.style.pointerEvents = 'none';
    tooltip.style.boxShadow = '0 2px 6px rgba(0,0,0,.18)';

    document.body.appendChild(tooltip);
    window.setTimeout(function () {
      if (tooltip.parentNode) tooltip.parentNode.removeChild(tooltip);
    }, 900);
  }

  function copySku(target, event) {
    var sku = target.textContent.trim();
    if (!sku) return;

    copyText(sku).then(function () {
      showCopiedTooltip(target, event);
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target.closest('[data-sku-copy]');
    if (!target) return;
    copySku(target, event);
  });

  document.addEventListener('keydown', function (event) {
    var target = event.target.closest('[data-sku-copy]');
    if (!target || (event.key !== 'Enter' && event.key !== ' ')) return;
    event.preventDefault();
    copySku(target, event);
  });

  function syncSkuLabels() {
    document.querySelectorAll('[data-product-sku][data-sku-copy]').forEach(function (element) {
      var value = element.textContent.trim();
      element.setAttribute('aria-label', 'Copy SKU ' + value);
    });
  }

  document.addEventListener('variant-change', function () {
    window.setTimeout(syncSkuLabels, 0);
  });

  syncSkuLabels();
})();
